import React, { useEffect } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
// import { v4 as uuid } from 'uuid'
import moment from 'moment-jalaali'
import {
  Box,
  // Button,
  Card,
  CardHeader,
  Divider,
  IconButton,
  List,
  ListItem,
  // ListItemAvatar,
  ListItemText,
  makeStyles,
} from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  selectorRecentlyScholarship,
  getRecentlyScholarship,
} from '../../../app/slices/dashboardSlice'

// const data = [
//   {
//     id: uuid(),
//     name: 'کاربر',
//     imageUrl: '/static/images/products/product_1.png',
//     updatedAt: moment().local('fa').subtract(2, 'hours'),
//   },
//   {
//     id: uuid(),
//     name: 'کاربر',
//     imageUrl: '/static/images/products/product_2.png',
//     updatedAt: moment().subtract(2, 'hours'),
//   },
//   {
//     id: uuid(),
//     name: 'کاربر',
//     imageUrl: '/static/images/products/product_3.png',
//     updatedAt: moment().subtract(3, 'hours'),
//   },
//   {
//     id: uuid(),
//     name: 'کاربر',
//     imageUrl: '/static/images/products/product_4.png',
//     updatedAt: moment().subtract(5, 'hours'),
//   },
//   {
//     id: uuid(),
//     name: 'کاربر',
//     imageUrl: '/static/images/products/product_5.png',
//     updatedAt: moment().subtract(9, 'hours'),
//   },
// ]

const useStyles = makeStyles(({
  root: {
    height: '100%',
    borderRadius: '20px',
  },
  image: {
    height: 48,
    width: 48,
  },
}))

const LatestProducts = ({ className, ...rest }) => {
  const classes = useStyles()
  const scholarships = useSelector(selectorRecentlyScholarship)
  const dispatch = useDispatch()
  // const [products] = useState(data)

  useEffect(() => {
    dispatch(getRecentlyScholarship())
  }, [])

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardHeader
        subtitle={`${scholarships?.length} in total`}
        title="بورسیه های اخیر"
      />
      <Divider />
      <List>
        {scholarships?.map((product, i) => {
          const fullname = [product?.user?.firstName, product?.user?.lastName].join(' ')
          const fullDate = ['زمان', moment(product?.createDate)?.format('jYYYY/jMM/jDD')].join(' ')
          return (
            <ListItem
              divider={i < scholarships?.length - 1}
              key={product?.id}
            >
              {/* <ListItemAvatar>
              <img
                alt="Product"
                className={classes.image}
                src={product.imageUrl}
              />
            </ListItemAvatar> */}
              <ListItemText
                primary={fullname}
                secondary={fullDate}
              />
              <IconButton
                edge="end"
                size="small"
              >
                <MoreVertIcon />
              </IconButton>
            </ListItem>
          )
        })}
      </List>
      <Divider />
      <Box
        display="flex"
        justifyContent="flex-end"
        p={2}
      >
        <Link
          to="/app/scholarships"
          color="primary"
          endIcon={<ArrowRightIcon />}
          size="small"
          variant="text"
        >
          مشاهده همه
        </Link>
      </Box>
    </Card>
  )
}

LatestProducts.propTypes = {
  className: PropTypes.string,
}

export default LatestProducts
